<template>
	<div>
		<detail-nav title="推广数据" @navigateBack="navigateBack"></detail-nav>

		<el-row class="margin-bottom-15">
			<div class="data-section">
				<div class="ds-left">
					<div class="ds-left_view">
						<img class="cover" :src="info.cover">
						<p class="title">{{info.title}}</p>
					</div>
					<div class="date">
						<i class="el-icon-date"></i>
						<p>{{info.event_date}}</p>
					</div>
					<img class="status-icon" src="../../assets/img/market/end-icon.png"
					  v-if="info.status == 3">
					<img class="status-icon" src="../../assets/img/promotion/closed.png"
					  v-else-if="info.status == 2">
					<img class="status-icon" src="../../assets/img/promotion/selling.png"
					  v-else-if="info.status == 1">
				</div>
				<div class="ds-right">
					<div style="border-left: 1px solid #EEEEEE;">
						<el-row>
							<el-col :span="8">
								<div class="ds-item">
									<div class="ds-option">
										<p>访客人数</p>
										<el-tooltip class="item" effect="dark" content="活动展现曝光的去重人数"
											placement="top-start">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
									<div class="ds-value">
										<p>{{info.visitor}}</p>
										<span>人</span>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="ds-item">
									<div class="ds-option">
										<p>成交金额</p>
										<el-tooltip class="item" effect="dark" content="活动有效期内,支付成功的订单金额汇总（含退款）"
											placement="top-start">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
									<div class="ds-value">
										<p>{{info.order_pay_money}}</p>
										<span>元</span>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="ds-item">
									<div class="ds-option">
										<p>成交单数</p>
										<el-tooltip class="item" effect="dark" content="活动有效期内,支付成功的订单数量（含退单）"
											placement="top-start">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
									<div class="ds-value">
										<p>{{info.order_pay_count}}</p>
										<span>单</span>
									</div>
								</div>
							</el-col>
						</el-row>
						<el-row style="margin-top: 50px;">
							<el-col :span="8">
								<div class="ds-item">
									<div class="ds-option">
										<p>退款订单量</p>
										<el-tooltip class="item" effect="dark" content="通过线上完成售后的活动订单数量"
											placement="top-start">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
									<div class="ds-value">
										<p>{{info.order_refund_count}}</p>
										<span>单</span>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="ds-item">
									<div class="ds-option">
										<p>退款金额</p>
										<el-tooltip class="item" effect="dark" content="通过线上完成售后的活动订单，退款金额汇总"
											placement="top-start">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
									<div class="ds-value">
										<p>{{info.order_refund_money}}</p>
										<span>元</span>
									</div>
								</div>
							</el-col>
							<el-col :span="8">
								<div class="ds-item">
									<div class="ds-option">
										<p>预计支出佣金</p>
										<el-tooltip class="item" effect="dark" content="专属合伙人分销订单(含退单)的佣金总和"
											placement="top-start">
											<i class="el-icon-question"></i>
										</el-tooltip>
									</div>
									<div class="ds-value">
										<p>{{info.order_pre_commission}}</p>
										<span>元</span>
									</div>
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</el-row>

		<el-row :gutter="15" class="margin-bottom-15">
			<el-col :span="12">
				<div class="chart-section">
					<div v-if="chartLoading">
						<p>商品成交情况</p>
						<div class="chart-container flex-center">
							<i class="el-icon-loading"></i>
						</div>
					</div>
					<div v-else-if="!chart.pay_detail.series.length">
						<p>商品成交情况</p>
						<div class="chart-container flex-center">
							<img style="width: 66%;" :src="imgpath +'/empty/bar_h.png'" alt="">
						</div>
					</div>
					<div v-else>
						<p>商品成交情况</p>
						<div id="ec_pay_detail" class="chart-container chart-large"></div>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="chart-section">
					<div v-if="chartLoading">
						<p>团效排名<span class="section-tip">仅展示销量前5名社群</span></p>
						<div class="chart-container flex-center">
							<i class="el-icon-loading"></i>
						</div>
					</div>
					<div v-else-if="!chart.group_rank.yAxis.length">
						<p>团效排名<span class="section-tip">仅展示销量前5名社群</span></p>
						<div class="chart-container flex-center">
							<img style="width: 66%;" :src="imgpath +'/empty/bar_h.png'" alt="">
						</div>
					</div>
					<div v-else>
						<p>团效排名<span class="section-tip">仅展示销量前5名社群</span></p>
						<div class="chart-othinfo">
							<div class="chart-othitem">
								<p>{{chart.group_rank.oth.pop_group}}</p>
								<div class="chart-othtitle">
									<p>推广社群</p>
									<el-tooltip class="item" effect="dark" content="推广分销该计划的社群总数量"
										placement="top-start">
										<i class="el-icon-question"></i>
									</el-tooltip>
								</div>
							</div>
							<div class="chart-othitem">
								<p>{{chart.group_rank.oth.pay_group}}</p>
								<div class="chart-othtitle">
									<p>成单社群</p>
									<el-tooltip class="item" effect="dark" content="所有推广社群中，成功出单的社群数量
"
										placement="top-start">
										<i class="el-icon-question"></i>
									</el-tooltip>
								</div>
							</div>
						</div>
						<div id="ec_group_rank" class="chart-container"></div>
					</div>
				</div>
			</el-col>
		</el-row>

		<el-row class="margin-bottom-15">
			<el-col :span="8">
				<div class="chart-section">
					<div v-if="chartLoading">
						<p>用户来源</p>
						<div class="chart-container flex-center" style="border-right: 1px solid #EEEEEE;">
							<i class="el-icon-loading"></i>
						</div>
					</div>
					<div v-else-if="!chart.source_user.length" style="border-right: 1px solid #EEEEEE;">
						<p>用户来源</p>
						<div class="chart-container flex-center">
							<img style="width: 87%;" :src="imgpath +'/empty/ring.png'" alt="">
						</div>
					</div>
					<div v-else>
						<p>用户来源</p>
						<div id="ec_source_user" class="chart-container" style="border-right: 1px solid #EEEEEE;">
						</div>
					</div>
					<div class="chart-tip">渠道来源用户占比</div>
				</div>
			</el-col>
			<el-col :span="16">
				<div class="chart-section">
					<div v-if="chartLoading">
						<p style="visibility: hidden;">用户来源</p>
						<div class="chart-container flex-center">
							<i class="el-icon-loading"></i>
						</div>
					</div>
					<div v-else-if="!chart.source_group.xAxis.length">
						<p style="visibility: hidden;">用户来源</p>
						<div class="chart-container flex-center">
							<img style="width: 66%;" :src="imgpath +'/empty/bar_h.png'" alt="">
						</div>
					</div>
					<div v-else>
						<p style="visibility: hidden;">用户来源</p>
						<div id="ec_source_group" class="chart-container"></div>
					</div>
					<div class="chart-tip">社群来源用户对比<span class="section-tip">（仅展示前10名社群数据）</span></div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		CombineEventData,
		CombineEventChart
	} from '@/api/event';
	import {
		getBrandPlanData,
		getBrandPlanChart
	} from '@/api/goods';
	import {
		baseURL
	} from '@/config';
	import detailNav from '@/components/detail-nav.vue';
	// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口
	import * as echarts from 'echarts/core';
	// 引入柱状图图表，图表后缀都为 Chart
	import {
		BarChart,
		PieChart
	} from 'echarts/charts';
	// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
	import {
		TitleComponent,
		TooltipComponent,
		GridComponent,
		DatasetComponent,
		TransformComponent,
		LegendComponent,
		DataZoomComponent,
		DataZoomSliderComponent
	} from 'echarts/components';
	// 标签自动布局，全局过渡动画等特性
	import {
		LabelLayout,
		UniversalTransition
	} from 'echarts/features';
	// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
	import {
		CanvasRenderer
	} from 'echarts/renderers';

	// 注册必须的组件
	echarts.use([
		TitleComponent,
		TooltipComponent,
		GridComponent,
		DatasetComponent,
		TransformComponent,
		BarChart,
		PieChart,
		LabelLayout,
		UniversalTransition,
		CanvasRenderer,
		LegendComponent,
		DataZoomComponent,
		DataZoomSliderComponent
	]);

	export default {
		components: {
			detailNav
		},
		data() {
			return {
				imgpath: baseURL + '/public/images',
				id: 0,
				info: {},
				chart: {},
				chartLoading: true,
				list_page: 0,
				activeName: 'all',
			}
		},
		created() {},
		destroyed() {
			window.removeEventListener('popstate', this.navigateBack, false);
		},
		mounted() {
			document.getElementsByClassName("father-main")[0].scrollTop = 0;
			let query = this.$route.query;
			if (query.id > 0) {
				this.id = query.id;
				this.getEventData();
				this.getEventChartData();
			}
			if (query.list_page) {
				this.list_page = query.list_page;
			}
			if (query.activeName) {
				this.activeName = query.activeName;
			}
			//监听浏览器返回
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.navigateBack, false);
			}
		},
		methods: {
			getEventData() {
				getBrandPlanData({
					id: this.id
				}).then(res => {
					if (res.code == 0) {
						this.info = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getEventChartData() {
				getBrandPlanChart({
					id: this.id
				}).then(res => {
					if (res.code == 0) {
						this.chart = res.data;
						// this.chart = {
						// 	pay_detail: {
						// 		xAxis: ['商品1','商品2','商品3'],
						// 		series: [1024,654,879]
						// 	},
						// 	group_rank: {
						// 		oth: {
						// 			pop_group: 321,
						// 			pay_group: 221
						// 		},
						// 		yAxis: ['长名字 长名字 长名字 社群1','社群2','社群3','社群4','社群5'],
						// 		series: [1024,654,879,489,654],
						// 	},
						// 	source_user: [
						// 		{
						// 			name: '卡片分享',
						// 			value: 123,
						// 		},
						// 		{
						// 			name: '社群搜索',
						// 			value: 32,
						// 		},
						// 		{
						// 			name: '短视频',
						// 			value: 21,
						// 		},
						// 		{
						// 			name: '经验内容',
						// 			value: 22,
						// 		},
						// 		{
						// 			name: '海报扫码',
						// 			value: 44,
						// 		},
						// 	],
						// 	source_group: {
						// 		xAxis: ['社群1','社群2','社群3','社群4','社群5'],
						// 		series: [1024,654,879,489,654],
						// 	},
						// }
						this.chartLoading = false;
						this.$nextTick(() => {
							this.initEC('ec_pay_detail');
							this.initEC('ec_group_rank');
							this.initEC('ec_source_user');
							this.initEC('ec_source_group');
						})
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 初始化指定的图表
			initEC: function(element_id) {
				var documentEle = document.getElementById(element_id);
				if (documentEle) {
					var myChart = echarts.init(documentEle);
					echartSetOption[element_id](myChart, this);
				}
			},
			navigateBack() {
				this.$router.go(-1)
			}
		}
	}

	const echartSetOption = {
		ec_pay_detail: function(chart, that) {
			var series = formatBarSeries_Max(that.chart.pay_detail.series);
			const option = {
				tooltip: {
					trigger: 'axis',
					formatter: '商品：{b}<br />销量：{c}',
					position: ['40%'],
					axisPointer: {
						type: 'none'
					}
				},
				grid: {
					left: '3%',
					right: '3%',
					top: '15%',
					bottom: that.chart.pay_detail.xAxis.length > 4 ? '15%' : '3%',
					containLabel: true
				},
				dataZoom: [{
					type: 'slider',
					show: that.chart.pay_detail.xAxis.length > 4,
					startValue: 0,
					endValue: 9
				}],
				xAxis: {
					type: 'category',
					data: that.chart.pay_detail.xAxis,
					axisLabel: {
						width: 84,
						height: 28,
						interval: 0,
						hideOverlap: true,
						overflow: 'truncate',
						color: '#999999',
						fontSize: 12,
						lineHeight: 14
					},
					axisTick: {
						show: false
					}
				},
				yAxis: {
					type: 'value',
					name: '销量',
					minInterval: 1,
					axisLabel: {
						color: '#999999',
						fontSize: 12
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true
					}
				},
				series: [{
					data: series,
					type: 'bar',
				}],
				itemStyle: {
					borderRadius: [4, 4, 0, 0]
				},
				barWidth: 17,
				color: '#0486FE',
			};
			chart.setOption(option);
		},
		ec_group_rank: function(chart, that) {
			var series = formatBarSeries_Max(that.chart.group_rank.series);
			const option = {
				tooltip: {
					trigger: 'axis',
					formatter: '社群：{b}<br />销量：{c}',
					axisPointer: {
						type: 'none'
					}
				},
				grid: {
					left: '3%',
					right: '10%',
					top: '10%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					axisLabel: {
						show: false
					},
					axisLine: {
						show: false
					},
					splitLine: {
					  show: false
					}
				},
				yAxis: {
					type: 'category',
					data: that.chart.group_rank.yAxis,
					inverse: true,
					minInterval: 1,
					axisLabel: {
						width: 72,
						overflow: 'truncate',
						interval: 0,
						color: '#999999',
						fontSize: 12
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: false
					},
				},
				series: [{
					data: series,
					type: 'bar',
					label: {
						show: true,
						position: 'right',
						color: '#909090',
						distance: 10
					},
					barCategoryGap: 20
				}],
				itemStyle: {
					borderRadius: [4, 4, 4, 4]
				},
				barWidth: 10,
				color: '#0486FE',
			};
			chart.setOption(option);
		},
		ec_source_user: function(chart, that) {
			const option = {
				tooltip: {
					trigger: 'item',
					formatter: '来源于 {b}',
				},
				legend: {
					orient: 'vertical',
						right: 30,
						top: 15,
						itemWidth: 8,
						itemHeight: 8,
					},
					color: [{
						type: 'linear',
						x: 1,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [{
							offset: 0,
							color: '#F8B950' // 0% 处的颜色
						}, {
							offset: 1,
							color: '#FE1D1D' // 100% 处的颜色
						}],
						global: false // 缺省为 false
					},
					'#0486FE',
					'#3DA2FF',
					'#83BCF0',
					'#7D8FB3',
					'#414ABB',
					'#FDC621'
				],
				series: [{
					name: '',
					type: 'pie',
					center: ['39%', '50%'],
					radius: ['30%', '50%'],
					label: {
						formatter: '{d}%',
						color: '#333333',
						fontSize: 12
					},
					labelLine: {
						length: 2,
						length2: 0
					},
					labelLayout: {
						align: 'center'
					},
					data: that.chart.source_user,
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			};
			chart.setOption(option);
		},
		ec_source_group: function(chart, that) {
			var series = formatBarSeries_Max(that.chart.source_group.series);
			const option = {
				tooltip: {
					trigger: 'axis',
					formatter: '社群：{b}<br />数量：{c}',
					axisPointer: {
						type: 'none'
					}
				},
				grid: {
					left: '3%',
					right: '3%',
					top: '18%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: that.chart.source_group.xAxis,
					axisLabel: {
						width: 36,
						overflow: 'truncate',
						interval: 0,
						color: '#999999',
						fontSize: 12
					},
					axisTick: {
						show: false
					}
				},
				yAxis: {
					type: 'value',
					minInterval: 1,
					axisLabel: {
						color: '#999999',
						fontSize: 11
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true
					}
				},
				series: [{
					data: series,
					type: 'bar'
				}],
				itemStyle: {
					borderRadius: [4, 4, 0, 0]
				},
				barWidth: 10,
				color: '#0486FE',
			};
			chart.setOption(option);
		}
	}

	// 格式化柱状图数据，将数值最大的元素设置成特殊颜色（渐变橙）
	function formatBarSeries_Max(series = []) {
		let max = {
			index: -1,
			value: 0
		};
		series.map(function(item, index) {
			if (Number(item) > max.value) max.index = index, max.value = item
		});
		if (max.index > -1) {
			series[max.index] = {
				value: max.value,
				itemStyle: {
					color: {
						type: 'linear',
						x: 1,
						y: 0,
						x2: 0,
						y2: 1,
						colorStops: [{
								offset: 0,
								color: '#F8B950' // 0% 处的颜色
							},
							{
								offset: 1,
								color: '#FE1D1D' // 100% 处的颜色
							}
						],
						global: false // 缺省为 false
					}
				}
			}
		};
		return series;
	}
</script>

<style scoped="scoped">
	.el-icon-question, .el-icon-date {
		color: #CCCCCC;
	}

	.data-section {
		padding: 10px 15px;
		display: flex;
		background: #FFFFFF;
		border-radius: 4px;
	}

	.ds-left {
		position: relative;
		padding-right: 30px;
	}

	.ds-left_view {
		display: flex;
		margin-top: 37px;
	}

	.cover {
		width: 160px;
		height: 90px;
		object-fit: cover;
		border-radius: 4px;
	}

	.title {
		margin-left: 7px;
		width: 246px;
		font-size: 24px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 30px;
	}

	.date {
		margin-top: 30px;
		padding-left: 10px;
		width: 310px;
		height: 32px;
		display: flex;
		align-items: center;
		background: #F2F6FC;
		border-radius: 4px;
	}

	.date p {
		margin-left: 10px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #0486FE;
		line-height: 32px;
	}

	.status-icon {
		width: 70px;
		height: 69px;
		position: absolute;
		right: 30px;
		bottom: 30px;
	}

	.ds-right {
		width: 100%;
		padding: 20px 0;
	}

	.ds-item {
		padding-left: 33%;
	}

	.ds-option {
		display: flex;
		align-items: center;
	}

	.ds-option p {
		margin-right: 4px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 22px;
	}

	.ds-value {
		margin-top: 6px;
		display: flex;
		align-items: flex-end;
	}

	.ds-value p {
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
	}

	.ds-value span {
		margin-left: 2px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 30px;
	}

	.chart-section {
		padding: 15px;
		background: #FFFFFF;
		border-radius: 4px;
	}
	
	.chart-tip {
		text-align: center;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 18px;
	}

	.section-tip {
		margin-left: 5px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
	}

	.chart-othinfo {
		margin-top: 20px;
		display: flex;
		align-items: center;
	}

	.chart-othitem:nth-child(2) {
		margin-left: 40px;
	}

	.chart-othitem>p {
		font-size: 32px;
		font-family: AppleSystemUIFont;
		color: #111111;
		font-weight: bold;
		line-height: 32px;
	}

	.chart-othtitle {
		margin-top: 7px;
		display: flex;
		align-items: center;
	}

	.chart-othtitle>p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 14px;
	}

	.chart-othtitle>i {
		margin-left: 5px;
	}

	.chart-container {
		width: 100%;
		height: 225px;
	}

	.chart-large {
		height: 300px;
	}

	.flex-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.margin-bottom-15 {
		margin-bottom: 15px;
	}
</style>
